import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/HOLEHE/HOLEHE_01.png";
import Img_Two from "./../../../../sources/imgs/HOLEHE/HOLEHE_02.png";
import Img_Three from "./../../../../sources/imgs/HOLEHE/HOLEHE_03.png";
import Img_Four from "./../../../../sources/imgs/HOLEHE/HOLEHE_04.png";
import Img_Five from "./../../../../sources/imgs/HOLEHE/HOLEHE_05.png";
import Img_Six from "./../../../../sources/imgs/HOLEHE/HOLEHE_06.png";
import Img_Seven from "./../../../../sources/imgs/HOLEHE/HOLEHE_07.png";
import Img_Eight from "./../../../../sources/imgs/HOLEHE/HOLEHE_08.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function HOLEHE (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> HOLEHE.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Holehe</span> es una <span className="span-white">herramienta de código abierto</span> desarrollada en <span className="span-pink">Python</span>, diseñada para investigaciones <i className="span-white">OSINT (Open Source Intelligence)</i>. Su principal función es <span className="span-white">verificar</span> si una dirección de <span className="span-pink">correo electrónico</span> está asociada a cuentas en más de <span className="span-white">120 plataformas en línea</span>, como <span className="span-blue">Twitter</span>, <span className="span-blue">Instagram</span>, <span className="span-blue">Imgur</span>, entre otras. Utiliza <span className="span-pink">funciones públicas</span>, como la <span className="span-white">recuperación de contraseñas</span>, para obtener información sin alertar al propietario del <span className="span-white">correo electrónico</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Instalación de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Para la <span className="span-white">Instalación</span> de la <span className="span-white">herramienta</span> <span className="span-yellow">Holehe</span> debemos <span className="span-white">ejecutar</span> los <span className="span-pink">siguientes comandos</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt update"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install python3-pip -y"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "pip3 install holehe"
            />

            <p>
                O, puedes <span className="span-white">descargar</span> la <span className="span-white">herramienta</span> desde su <span className="span-white">repositorio oficial de GitHub</span>: <a className="span-white" href="https://github.com/megadose/holehe.git" target="_blank" rel="noopener noreferrer">GitHub de Holehe</a>.
            </p>

            <p>
                Puedes obtener el <span className="span-white">enlace</span> en tus <span className="span-pink">portapapeles</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "https://github.com/megadose/holehe.git"
            />

            <p>
                <span className="span-pink">Clonando</span> el <span className="span-pink">repositorio</span> e <span className="span-pink">instalando</span> la herramienta:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo apt install git -y"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "git clone https://github.com/megadose/holehe.git"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "cd holehe"
            />

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "sudo python3 setup.py install"
            />

            <p>
                Tal como se realiza en las <span className="span-white">siguientes imagenes</span> de <span className="span-pink">ejemplo</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"1. Comandos de instalación de HOLEHE."}
            />

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"2. Comandos de instalación de HOLEHE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Información y ayuda de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Podemos obtener <span className="span-pink">información</span> de uso de <span className="span-yellow">Holehe</span> y su <span className="span-white">documentación</span>, ejecutando el <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe -h"
            />

            <p>
                Tal como en la siguiente <span className="span-white">imagen</span>:
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"3. Comando de información de HOLEHE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Uso de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                El uso de ha <span className="span-pink">herramienta</span> es muy simple, basta con <span className="span-pink">ejecutar</span> el <span className="span-white">comando de ejecución</span>, acompañado del <span className="span-white">correo electronico</span> al cual deseamos encontrar sus <span className="span-pink">cuentas</span>:
            </p>

            <p>
                Tal como la <span className="span-pink">siguiente estructura</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe <correo-electronico>"
            />

            <p>
                Donde:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-white">&lt;correo-electronico&gt;</span> <span className="span-blue">-></span> <span className="span-pink">Dirección de correo electronico el cual se desea reconocer.</span>
                    </p>
                </li>
            </ul>

            <p>
                Un <span className="span-white">ejemplo</span> de <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe test@gmail.com"
            />

            <p>
                Imagen de <span className="span-white">ejemplo</span>:
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"4. Comando básico de HOLEHE."}
            />

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"5. Resultados de comando básico de HOLEHE."}
            />

            <p>
                Donde:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        Verde: <span className="span-white">El correo está registrado</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Rojo/Purpura</span>: <span className="span-white">El correo no está registrado o ocurrio un error</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-yellow">Amarillo</span>: <span className="span-white">No se pudo determinar o hay un límite de tasa alcanzado</span>.
                    </p>
                </li>
            </ul>

            <p>
                <span className="span-yellow">Nota:</span> La <span className="span-pink">confiabilidad</span> de las <span className="span-white">búsquedas</span> de <span className="span-yellow">Holehe</span> es <span className="span-pink">alta</span> dentro de su <span className="span-white">alcance</span>, pero tiene <span className="span-pink">limitaciones importantes</span> que debes conocer si planeas usarla. 
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Parametros de comandos de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Podemos agregar <span className="span-white">múltiples parametros</span> a nuestros <span className="span-pink">comandos</span>, los cuales pueden ser muy utiles.
            </p>

            <p>
                Algunos de ellos son:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <i className="span-white">--only-used</i> <span className="span-blue">-></span> <span className="span-pink">Muestra solo los sitios donde el correo está registrado.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--no-clear</i> <span className="span-blue">-></span> <span className="span-pink">Evita que se limpie la pantalla antes de mostrar los resultados.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--csv</i> <span className="span-blue">-></span> <span className="span-pink">Exporta los resultados a un archivo .csv.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--no-color</i> <span className="span-blue">-></span> <span className="span-pink">Desactiva la salida en color.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--timeout</i> <span className="span-white">&lt;segundos&gt;</span> <span className="span-blue">-></span> <span className="span-pink">Tiempo máximo de espera para respuestas HTTP.</span>
                    </p>
                </li>
                <li>
                    <p>
                        <i className="span-white">--no-password-recovery</i> <span className="span-blue">-></span> <span className="span-pink">Desactiva el método de recuperación de contraseña para evitar detección.</span>
                    </p>
                </li>
            </ul>

            <p>
                Un <span className="span-white">ejemplo</span> de <span className="span-pink">comando</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe test@gmail.com --only-used --no-clear --timeout 6 --no-password-recovery"
            />

            <p>
                Visualizando:
            </p>

            <Img
                img = {Img_Six}
                alt = {"Imagen 6. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"6. Comando con parametros extra de HOLEHE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Almacenar resultados obtenidos de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Holehe</span> permite el <span className="span-pink">almacenamiento</span> de los <span className="span-white">resultados</span> de una busqueda en archivos <i className="span-white">.csv</i>.
            </p>

            <p>
                Para ello, realizamos el uso del <span className="span-pink">parametro</span> <i className="span-white">--csv</i>.
            </p>

            <p>
                Con la <span className="span-white">estructura</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe <correo-electronico> --csv"
            />

            <p>
                Para nuestro <span className="span-pink">ejemplo</span>:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "holehe test@gmail.com --csv"
            />

            <p>
                Realizando:
            </p>

            <Img
                img = {Img_Seven}
                alt = {"Imagen 7. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"7. Comando de almacenamiento de resultados de HOLEHE."}
            />

            <Img
                img = {Img_Eight}
                alt = {"Imagen 8. HOLEHE."}
                title = {"Descripcción de imagen."}
                text = {"8. Documento de resultados de HOLEHE."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Consideraciones éticas de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Al utilizar <span className="span-yellow">Holehe</span>, toma en cuenta las <span className="span-pink">siguientes consideraciones</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-yellow">Holehe</span> <span className="span-white">NO hackea</span>, <span className="span-white">NO roba contraseñas NI realiza acciones maliciosas</span>.
                    </p>
                </li>
                <li>
                    <p>
                        Se limita a usar <span className="span-pink">información expuesta públicamente</span> en funciones como <i className="span-white">"¿Olvidaste tu contraseña?"</i>.
                    </p>
                </li>
                <li>
                    <p>
                        Úsalo únicamente con <span className="span-pink">fines éticos</span> o de <span className="span-white">investigación OSINT</span>, nunca en <span className="span-pink">correos ajenos sin autorización</span>.
                    </p>
                </li>
            </ol>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Recursos extra de Holehe.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseas <span className="span-white">conocer</span> más sobre <span className="span-yellow">Holehe</span>, puedes consutar otros <span className="span-pink">recursos</span>:
            </p>

            <ul className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Tutorial de uso en video</span>: Puedes consultar el <span className="span-pink">tutorial de uso</span> desde: <a className="span-white" href="https://www.youtube.com/watch?v=L87T4iw5170" target="_blank" rel="noopener noreferrer">https://www.youtube.com/watch?v=L87T4iw5170</a>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Artículo técnico</span>: Para más <span className="span-pink">información</span>, puedes consultar el siguiente <span className="span-white">artículo</span>: <a className="span-white" href="https://hacklido.com/blog/341-holehe-the-email-investigation-tool-you-need-for-osint" target="_blank" rel="noopener noreferrer">https://hacklido.com/blog/341-holehe-the-email-investigation-tool-you-need-for-osint</a>
                    </p>
                </li>
            </ul>
        </>
    );
}